import * as constants from './constants'

export const login = (email, password, remember = false, translate) => ({
    type: constants.LOGIN,
    // email is used as a entity key, always use same capitalization
    email: email.toLowerCase(),
    password,
    remember,
    translate,
})

export const createAccount = (
    firstName,
    lastName,
    email,
    password,
    nif,
    country,
    customerType,
    customerRegNr,
    businessName,
    phone
) => ({
    type: constants.CREATE_ACCOUNT,
    firstName,
    lastName,
    // email is used as a entity key, always use same capitalization
    email: email.toLowerCase(),
    password,
    nif,
    country,
    customerType,
    customerRegNr,
    businessName,
    phone,
})

export const setAuthenticatedUser = (user = {}) => ({
    type: constants.SET_AUTHENTICATED_USER,
    ...user,
})

export const refreshAuthenticatedUser = () => ({
    type: constants.REFRESH_AUTHENTICATED_USER,
})

export const logout = () => ({
    type: constants.LOGOUT,
})

export const resetPassword = email => ({
    type: constants.RESET_PASSWORD,
    email,
})

export const setLatestConfirmedWaitingList = result => ({
    type: constants.SET_LATEST_CONFIRMED_WAITING_LIST,
    result,
})

export const getToken = (email, password) => ({
    type: constants.GET_TOKEN,
    email,
    password,
})

export const setToken = ({ expiresIn, ...userEntity }) => ({
    type: constants.SET_TOKEN,
    ...userEntity,
    expiresIn,
})

export const restoreUserSession = () => ({
    type: constants.RESTORE_USER_SESSION,
})
